import React, { Fragment, useState } from "react";
import {withStyles} from "@material-ui/core";
import Reserve from "./Reserve"
import Retrieve from "./Retrieve"
import Counsel from "./Counsel"
import ReserveCancel from "./ReserveCancel"
import ReserveInstall from "./ReserveInstall";
import ReservePlace from "./ReservePlace";
import ReserveNoDate from "./ReserveNoDate";
import SearchByReserveNum from "./SearchByReserveNum";
import ReserveCall from "./ReserveCall";

const styles = (theme) => ({
    button:{
        border: "none",
        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.1)",
        margin: "10px 20px",
        backgroundColor: theme.color.button.background_white,
        width: "70%",
        borderRadius: "10px",
        height: "40px",
    }
});

const menu_map = {
    "reserve": ["출장접수 예약", Reserve],
    "retrieve": ["예약 확인/취소", Retrieve],
    "verify": ["고객서비스 상담", Counsel],
    "cancel":["예약 취소", ReserveCancel],
    "install":["설치 형태", ReserveInstall],
    "place": ["사용장소", ReservePlace],
    "noReserveDate": ["No date modal", ReserveNoDate],
    "searchByReserveNum": ["접수번호 조회", SearchByReserveNum],
    "reserveCall":["전화상담예약", ReserveCall],
}

function ModalTest(props){
    const { data, classes } = props;
    const handleClick = (e, key, info) => {
        console.log(data)
        openModal(key, info)
    }
    const [modalOpen, setModalOpen] = useState(
        {
            "reserve":false,
            "retrieve":false,
            "verify":false,
        }
    );
    const openModal = (key, info) =>{
        const [title, component] = info
        console.log(title)
        console.log(component)
        setModalOpen( prev => ({
            ...prev,
            [key]:true
        }))
    }
    const closeModal = (key) =>{
        setModalOpen( prev =>({
                ...prev,
                [key]:false
            })
        )
    }


    return <Fragment>
        {Object.keys(menu_map).map( (m, index)=>(
            <Fragment key={index}>
                <button key={`key-${index}`} onClick={(e)=>{handleClick(e,m, menu_map[m])}} className={classes.button}> {menu_map[m][0]} </button>
                
                {index===0 && <Reserve modalOpen={modalOpen[m]} modalClose={()=>closeModal(m)} data={{orgData:{}, modalValue:{}}}/>}
                {index===1 && <Retrieve modalOpen={modalOpen[m]} modalClose={()=>closeModal(m)}/>}
                {index===2 && <Counsel modalOpen={modalOpen[m]} modalClose={()=>closeModal(m)}  data={{modal:{data:{}}}}/>}
                {index===3 && <ReserveCancel modalOpen={modalOpen[m]} modalClose={()=>closeModal(m)}/>}
                {index===4 && <ReserveInstall modalOpen={modalOpen[m]} modalClose={()=>closeModal(m)}/>}
                {index===5 && <ReservePlace modalOpen={modalOpen[m]} modalClose={()=>closeModal(m)}/>}
                {index===6 && <ReserveNoDate modalOpen={modalOpen[m]} modalClose={()=>closeModal(m)}/>}
                {index===7 && <SearchByReserveNum modalOpen={modalOpen[m]} modalClose={()=>closeModal(m)}/>}
                {index===8 && <ReserveCall modalOpen={modalOpen[m]} modalClose={()=>closeModal(m)}/>}
            </Fragment>
            ))
        }
    </Fragment>

}
export default withStyles(styles)(ModalTest);